import React, { useEffect } from "react";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import PropTypes from "prop-types";
import { actionCreators } from "./redux/RecurringRevenueSagas";
import { useDispatch, useSelector } from "react-redux";
import PeriodType from "./smartComponents/PeriodType";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import DatePicker from "./smartComponents/DatePicker";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import RevenueChart from "./smartComponents/RevenueChart";
import IncludeReturns from "./smartComponents/IncludeReturns";
import "./RecurringRevenue.css.scss";
// import CompareDates from "./smartComponents/CompareDates";
// import VcCompare from "../../../../components/vcCompare/vcCompare";
// import CompareType from "./smartComponents/CompareType";

const recurringRevenueModule = ({ params }) => {
  const dispatch = useDispatch();
  const {
    isLoading,
    filtersDirty,
    updatesLoading,
    selectedRequestDates: { startDate, endDate },
    selectedFilters: { compare }
  } = useSelector((state) => state.serviceRevenue);
  const renderUpdateBtn = () => {
    let checkForInvalidDate = startDate !== "Invalid date" && endDate !== "Invalid date";
    if (filtersDirty && !isLoading && checkForInvalidDate) {
      return (
        <button className="submit" onClick={() => dispatch(actionCreators.updateData())}>
          Update
        </button>
      );
    }
  };

  const renderResetBtn = () => {
    if (filtersDirty && !isLoading) {
      return (
        <button className="submit reset" onClick={() => dispatch(actionCreators.resetFilters())}>
          Reset
        </button>
      );
    }
  };

  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(params));
  }, []);

  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div className="top-filter__left">
              {/*<div className="select-box-no-width">*/}
              {/*  <p>Compare Dates</p>*/}
              {/*  <CompareDates />*/}
              {/*</div>*/}
              <div className="select-box-no-width">
                <p>Net Revenue</p>
                <IncludeReturns />
              </div>
            </div>

            <div className="top-filter">
              <div>
                <div className="top-filter__left"></div>
              </div>
              <div className="top-filter__right">
                <div className="select-box-no-width">
                  <p>Period Type</p>
                  <PeriodType />
                </div>

                <div className="select-box-no-width date-range-select-box">
                  <p>Date Range</p>
                  <CustomDateRanges />
                </div>
                <div className="date-select-box select-box-no-width multi">
                  <p>Date</p>
                  <DatePicker />
                </div>
                {/*{compare && (*/}
                {/*  <>*/}
                {/*    <div className="vc-compare">*/}
                {/*      <VcCompare />*/}
                {/*    </div>*/}
                {/*    <div className="select-box-no-width compare-period-select-box">*/}
                {/*      <p>Compare Period</p>*/}
                {/*      <CompareType />*/}
                {/*    </div>*/}
                {/*  </>*/}
                {/*)}*/}
                {renderUpdateBtn()}
                {renderResetBtn()}
              </div>
            </div>
          </div>
        </div>
        <div data-testid={"charts-container"} className="chart-root">
          {updatesLoading ? <LoadingAnimation text="Updating data..." /> : <RevenueChart />}
        </div>
      </div>
    );
  };
  return (
    <div id="RecurringRevenue-root">
      <SectionToggle
        autoHeight
        paddingBottom={0}
        height={690}
        title={"Recurring and Membership Revenue"}
        learnMore={<p style={{ fontSize: "16px", margin: 0 }}>as a % of all Service Revenue</p>}
        isLoading={isLoading}
        content={content()}
      />
    </div>
  );
};
export default recurringRevenueModule;
recurringRevenueModule.propTypes = {
  params: PropTypes.object
};
